<template>
    <div class="story-maker-sticker-menu-music">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :ref="`music-preview`"></audio>
        <div class="header-menu">
            <p>Musique</p>
        </div>
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input placeholder="Rechercher un morceau" v-model="models.search">
        </div>
        <!-- <div class="navigation">
            <div class="item-nav active">Pour vous</div>
            <div class="item-nav">Parcourir</div>
        </div> -->

        <div class="list-item hide-scrollbar">
            <span class="loader" v-if="stateLoader"></span>
            <div class="item" v-else v-for="(music,index) in (models.search.length ? musics : dataInstagramDefault.musics)" @click="selectMusic(music)" :key="`music${index}`">
                <img :src="music.track.cover_artwork_thumbnail_uri">

                <div class="info">
                    <h5>{{ music.track.title }}</h5>
                    <p>{{`${music.track.display_artist} • ${Math.floor(music.track.duration_in_ms / 60000)}:${(('0' + Math.floor((music.track.duration_in_ms % 60000) / 1000)).slice(-2))}`}}</p>
                </div>
               
                <div class="btn-control">
                    <div class="circle" @click.stop="toogleMusic(music)" :class="{play : urlMusicPlaying == music.track.progressive_download_url}">
                      
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>
<script>
    import store from './../../../../../store/index.js';
    import minxinPost from '../../../../mixins/Posts.vue'

    export default {
        mixins: [minxinPost],

        props: {
            dataInstagramDefault: Object,
        },
        
        data() {
            return {
                models: {
                    search: ''
                },
                musics: [],
                stateLoader: false,
                timeoutInitSearch: null,
                urlMusicPlaying: null,
            }
        },

        methods: {
            async searchMusic() {
                this.pauseMusic()
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = false
                if(!this.models.search) return
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.story_config && p.story_config.created) || this.allPages.find(p => p.story_config && p.story_config.created)
                    this.musics = []
                    if (page) {
                        this.stateLoader = true
                        this.musics = (await this.getMusicInstagram(page.id, this.models.search)).body.musics
                        this.stateLoader = false
                    }
                },1000)
            },

            async selectMusic(music) {
                if (this.urlMusicPlaying) this.toogleMusic()
                this.$emit('addSticker','music', {
                    data: {
                        music
                    }
                })
            },

            toogleMusic(music) {
                let audio = this.$refs['music-preview'];

                if (!music) {
                    this.urlMusicPlaying = null;
                    audio.pause();
                    return;
                }

                if (music.track.progressive_download_url === audio.src) {
                    if (audio.paused) {
                        audio.play();
                        this.urlMusicPlaying = music.track.progressive_download_url;
                    } else {
                        audio.pause();
                        this.urlMusicPlaying = null;
                    }
                } else {
                    audio.src = music.track.progressive_download_url;
                    audio.currentTime = music.track.highlight_start_times_in_ms[0] / 1000;
                    this.urlMusicPlaying = music.track.progressive_download_url;
                    audio.play();
                }
            },

            pauseMusic() {
                let audio = this.$refs['music-preview'];
                audio.pause();
                this.urlMusicPlaying = null;
            }
        },

        watch: {
            ['models.search'](newValue, oldValue) {
                this.searchMusic()  
            },
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>